import { Flex, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { some } from "lodash";
import { DataTableColumn } from "mantine-datatable";

import ActionIcon from "../../../components/ActionIcon/ActionIcon.tsx";
import SvgVisibility from "../../../components/Icons/Visibility.tsx";
import Table from "../../../components/Table/Table.tsx";
import { TableRow } from "../../../components/Table/types.ts";
import TableFilesDisplay from "../../../components/TableFilesDisplay/TableFilesDisplay.tsx";
import { TransactionHistory } from "../../../types/transactionHistory.ts";
import { toLocalDate } from "../../../utils/date.ts";

interface Props {
  data: TransactionHistory;
}

export const PODocsModal = ({ data }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);

  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "id",
      hidden: true,
    },
    {
      accessor: "poFile",
      title: "PO Docs",
    },
    {
      accessor: "poNumber",
      title: "PO Number",
    },
    {
      accessor: "poDate",
      title: "PO Date",
    },
  ];
  const rows = [
    {
      id: data.id,
      poFile: data.poFile && <TableFilesDisplay files={[data.poFile]} />,
      poNumber: data.poNumber,
      poDate: toLocalDate(data.poDate),
    },
  ];

  const hasData = some([data.poFile, data.poNumber, data.poDate]);

  return (
    <>
      <ActionIcon variant={hasData ? "success" : "error"} onClick={open}>
        <SvgVisibility />
      </ActionIcon>
      <Modal title="PO Docs" size="auto" opened={opened} onClose={close}>
        <Flex direction="column" gap={8}>
          <Table
            minWidth="350px"
            columns={columns}
            rows={rows}
            verticalAlignment="top"
          />
        </Flex>
      </Modal>
    </>
  );
};
